export const eventPage = (() => {
    const eventContainer = document.getElementById('eventpage-container');

    if (!eventContainer) return;

    if(window.TellusId.length) {
        fetchEventData();
    }

    addEvents();

    function addEvents() {

        const toggleButtons = document.querySelectorAll('.js-activity-toggle');
        toggleButtons.forEach(button => {
            button.addEventListener('click', function() {
                const currentRow = this.closest('.event-activity--row');
                const allRows = document.querySelectorAll('.event-activity--row');

                // Hide current row
                currentRow.style.display = 'none';

                // Show all other rows
                allRows.forEach(row => {
                    if (row !== currentRow) {
                        row.style.display = 'flex';
                    }
                });
            });
        });

        const videoPreviews = document.querySelectorAll('.js-preview-video');
        videoPreviews.forEach(el => {
            el.addEventListener('click', function() {
                this.setAttribute('hidden', '');
                const nextElement = this.nextElementSibling;
                if (nextElement) {
                    nextElement.removeAttribute('hidden');
                }
            });
        });

        const eventSelect = document.querySelector('.js-event-select');
        if (eventSelect != null) {
            eventSelect.addEventListener('click', function() {
                this.parentElement.classList.toggle('open');
            });
        }

        const eventSelectors = document.querySelectorAll('.js-onselect');
        eventSelectors.forEach(item => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                console.log(this.getAttribute('href'));
                const yPos = window.scrollY;
                document.getElementById('y-pos').value = yPos;
                document.getElementById('s-form').action = this.getAttribute('href');
                document.getElementById('s-form').submit();
            });
        });

    }

    function fetchEventData() {
        const endpoint = `/api/events/event?id=${window.TellusId}&sessionId=${window.TellusSessionId}`;

        fetch(endpoint, {
            method: "GET",
        }).
        then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        }).
        then((data) => {
            handleEventState(data);
            handleAgenda(data);
        })
        .catch((error) => {
            console.error('Error fetching events:', error);
        }); 
    }

    function handleEventState(eventData) {
        if(!eventData.isFullyBooked && !eventData.showWaitlist) {
            eventContainer.querySelector('.js-signup').removeAttribute('hidden');
        }
        if(eventData.isFullyBooked) {
             eventContainer.querySelector('.js-fullyboked').removeAttribute('hidden');           
        }
        if(eventData.showWaitlist) {
             eventContainer.querySelector('.js-waitlist').removeAttribute('hidden');           
        }        
    }

    function handleAgenda(eventData) {
        if(eventData.sessions.length) {

            let agentaContent = '';
            let firstDate = '';
            if(eventData.agendaDays.length) {
                firstDate = eventData.agendaDays[0].date;
              eventData.agendaDays.forEach(ag => {
                agentaContent += `
                    <button class="btn btn--secondary btn--sm" data-date="${ag.date}">
                        ${ag.day}
                        ${ag.month}
                    </button>`
                });           
                agentaContent = `<div class="event-page__agenda__head">${agentaContent}</div>`              
            }    

            let sessionContent = '';            
            eventData.sessions.forEach(ev => {
                const timeStart = new Date(ev.starttime).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit',hour12: false});
                const timeEnd = new Date(ev.endtime).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit',hour12: false});                 
                sessionContent += `
                    <div class="event-page__agenda__session--item" data-date="${ev.starttime.split("T")[0]}" hidden>
                        <div class="session-times">${timeStart} - ${timeEnd}</div>
                        <div class="session-info"><div class="session-name">${ev.name}</div> ${ev.description != null ? ev.description : ''}</div>
                    </div>`
            });

            sessionContent = `<div class="event-page__agenda__session js-sessions">${sessionContent}</div>` 

            const agendaEl = document.getElementById('event-agenda');
            agendaEl.innerHTML += agentaContent + sessionContent;
            agendaEl.removeAttribute('hidden'); 
            showAgendaDate(firstDate);
            addBtnEvents();
        }
    }

    function showAgendaDate(date) {
        var elAgenda = document.getElementById('event-agenda');
        const elements = elAgenda.querySelectorAll('.js-sessions div[data-date]');
        const btns = elAgenda.querySelectorAll('button[data-date]');

        elements.forEach(el => {
            if(el.getAttribute('data-date') == date) {
                el.removeAttribute('hidden');
            } else {
                el.setAttribute('hidden', '');
            }
        });

        btns.forEach(el => {
            if(el.getAttribute('data-date') == date) {
                el.classList.add('btn--primary');
                el.classList.remove('btn--secondary');               
            } else {
                el.classList.remove('btn--primary');
                el.classList.add('btn--secondary');  
            }
        }); 
    }

    function addBtnEvents() {
        var elAgenda = document.getElementById('event-agenda');
        const btns = elAgenda.querySelectorAll('button[data-date]');

        btns.forEach(button => {
            button.addEventListener('click', function() {
            showAgendaDate(this.dataset.date);            
            });
        });       
    }
})();
